import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import LoginForm from "./components/LoginForm";
import { Stack } from "@mui/material";
import AuthPage from "../../Components/AuthPage";
import OtpForm from "./components/OtpForm";

const Otp = () => {
  return (
    <AuthPage title="Otp" maxWidth={350}>
      <Box
        sx={{
          height: "50vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Stack direction="column" alignItems="center" spacing={6}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h4" align="center" gutterBottom>
              Welcome to Digital SACCO.
            </Typography>
            <Typography sx={{ color: "text.secondary" }} align="center">
              Provide OTP sent to your mobile
            </Typography>
          </Box>
        </Stack>

        <Box>
          <OtpForm />
        </Box>
      </Box>
    </AuthPage>
  );
};

export default Otp;
